import { flowRight } from 'lodash';
import { connect } from '../components/runtime-context';
import withHocName from './with-hoc-name';
import withCardBorderWidth from './with-card-border-width';
import withIsFeedDesignEnabled from './with-is-feed-design-enabled';
import { getSection } from '../selectors/section-selectors';
import { getLayoutType } from '../selectors/layout-selectors';
import { getAppSettingsNumber } from '../selectors/app-settings-base-selectors';
import { SECTION_HOMEPAGE, isLayoutNameTextOnImage, getLayoutName } from '@wix/communities-blog-client-common';

const mapRuntimeToProps = (state, { borderWidth: cardBorderWidth, applyFeedDesign }) => {
  const section = getSection(state) || SECTION_HOMEPAGE;
  const layoutName = getLayoutName(getLayoutType(state, section));
  const feedBorderWidth = isLayoutNameTextOnImage(layoutName)
    ? 0
    : getAppSettingsNumber(state, `post-${section}-borderWidth`);

  return { borderWidth: applyFeedDesign ? feedBorderWidth : cardBorderWidth };
};

export default flowRight(
  withCardBorderWidth,
  withIsFeedDesignEnabled,
  connect(mapRuntimeToProps),
  withHocName('WithFeedBorderWidth'),
);
